// PROJECT SLIDER JS

var swiper = new Swiper(".myProducts", {
    slidesPerView: 6,
    spaceBetween: 20,
    pagination: {
        el: '.product-pagination',
        type: 'progressbar',
    },
    // autoplay: {
    //     delay: 3000, 
    //     disableOnInteraction: false, 
    // },
    navigation: {
        nextEl: ".prod-next",
        prevEl: ".prod-prev",
    },
    speed: 1000,
    breakpoints: {
        1400: {
            slidesPerView: 6,
            spaceBetween: 20,
        },
        1200: {
            slidesPerView: 5,
            spaceBetween: 10,
        },
        992: {
            slidesPerView: 4,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 10,
        },
        100: {
            slidesPerView: 2,
            spaceBetween: 5,
        }
    }
});

var swiper = new Swiper(".myWeekend", {
    slidesPerView: 4,
    spaceBetween: 20,
    pagination: {
        el: '.weekend-pagination',
        type: 'progressbar',
    },
    // autoplay: {
    //     delay: 3000, 
    //     disableOnInteraction: false, 
    // },
    navigation: {
        nextEl: ".weekend-next",
        prevEl: ".weekend-prev",
    },
    speed: 500,
    breakpoints: {
        1400: {
            slidesPerView: 4,
            spaceBetween: 14,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 10,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 10,
        },
        200: {
            slidesPerView: 2,
            spaceBetween: 5,
        }
    }
});

var swiper = new Swiper(".myReviews", {
    slidesPerView: 2,
    spaceBetween: 20,
    pagination: {
        el: '.review-pagination',
        clickable: true,
    },
    autoplay: {
        delay: 3000, 
        disableOnInteraction: false, 
    },
    loop: true,
    speed: 1000,
    breakpoints: {
        1200: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        992: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        100: {
            slidesPerView: 1,
            spaceBetween: 20,
        }
    }
});

var swiper = new Swiper(".myPayment", {
    slidesPerView: 3,
    spaceBetween: 20,
    navigation: {
        nextEl: ".payment-next",
        prevEl: ".payment-prev",
    },
    // autoplay: {
    //     delay: 3000, 
    //     disableOnInteraction: false, 
    // },
    loop: true,
    speed: 1000,
    breakpoints: {
        1200: {
            slidesPerView: 3,
            spaceBetween: 10,
        },
        992: {
            slidesPerView: 2,
            spaceBetween: 10,
        },
        100: {
            slidesPerView: 1,
            spaceBetween: 10,
        }
    }
});

// document.addEventListener('DOMContentLoaded', function () {
// var cartLink = document.querySelector('.header-cart-link');
// var cartDrawer = document.querySelector('cart-drawer');

// if (cartLink && cartDrawer) {
//     cartLink.addEventListener('click', function (e) {
//     e.preventDefault();
//     cartDrawer.classList.remove('is-empty'); 
//     if (typeof cartDrawer.open === 'function') {
//         cartDrawer.open(cartLink);
//     }
//     });
// }
// });

  (function () {
    var header = document.querySelector('.custom-header');
    if (!header) return;

    var mainHeader = header.querySelector('.main-header');
    var headerBottom = header.querySelector('.header-bottom');
    if (!mainHeader) return;

    // Spacer — dono fixed honge to layout gap na aaye
    var spacer = document.createElement('div');
    spacer.className = 'header-spacer';
    var lastEl = headerBottom || mainHeader;
    lastEl.parentNode.insertBefore(spacer, lastEl.nextSibling);

    var triggerPoint = mainHeader.offsetTop;

    function applyStickyPositions() {
      // header-bottom ko main-header ke theek neeche rakho
      if (headerBottom) {
        headerBottom.style.top = mainHeader.offsetHeight + 'px';
      }
      // spacer = dono ki total height
      var total = mainHeader.offsetHeight + (headerBottom ? headerBottom.offsetHeight : 0);
      spacer.style.height = total + 'px';
    }

    function onScroll() {
      if (window.scrollY > triggerPoint) {
        if (!header.classList.contains('is-sticky')) {
          applyStickyPositions();
          header.classList.add('is-sticky');
        }
      } else {
        header.classList.remove('is-sticky');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (header.classList.contains('is-sticky')) applyStickyPositions();
    }, { passive: true });
    onScroll();
  })();

  
// RESPONSIVE MENU ENTRY JS

jQuery('.ham-menu-btn').click(function(){
	jQuery('.responsive-menu').addClass('active');
    jQuery('body').addClass('stop-scroll');
});

// RESPONSIVE MENU EXIT JS

jQuery('.respon-cross a').click(function(){
	jQuery('.responsive-menu').removeClass('active');
    jQuery('body').removeClass('stop-scroll');
});

// RESPONSIVE MENU UL TOGGLE JS

jQuery(document).ready(function () {
    jQuery('.responsive-links ul li > a').click(function (e) {
        if (jQuery(this).siblings('ul').length > 0) {
            e.preventDefault();
            e.stopPropagation();
            
            jQuery('.responsive-links ul li > a').not(this).siblings('ul').slideUp();
            jQuery('.responsive-links ul li > a').not(this).parent().removeClass('active');

            jQuery(this).siblings('ul').slideToggle();
            jQuery(this).parent().toggleClass('active');
        }
    });
});